import React from 'react';
import type { BundleId } from '../../data/pricing';
import { useLanguage } from '../../contexts/LanguageContext';
import { bundleName, bundleSuggestionForIndividual, formatMoney, priceIndividual } from '../../utils/pricing';
import { buttonClasses } from '../../utils/buttonStyles';
import { WarrantyTag } from '../ui/WarrantyTag';
import { warrantyConfig } from '../../data/pricing';
type BundleSuggestOfferProps = {
  qty: number;
  onAccept: (id: BundleId) => void;
  onDecline: () => void;
};
export function BundleSuggestOffer({
  qty,
  onAccept,
  onDecline
}: BundleSuggestOfferProps) {
  const {
    lang
  } = useLanguage();
  const s = bundleSuggestionForIndividual(qty);
  const ind = priceIndividual(qty);
  if (!s) return null;
  const m = (n: number) => formatMoney(n, lang);
  const message = s.diff <= 0 ? `The ${bundleName(s.bundle, lang)} gives you ${s.extraLights > 0 ? `${s.extraLights} more light${s.extraLights > 1 ? 's' : ''}` : 'the same lights'} for ${m(Math.abs(s.diff))} less.` : `For ${m(s.diff)} more, get ${s.extraLights} more light${s.extraLights > 1 ? 's' : ''} as a complete ${bundleName(s.bundle, lang)}.`;
  return <div data-id="element-667" data-mp="12m0yzvnl0rwt">
      <h2 id="funnel-title" className="mt-3 font-display text-4xl font-semibold uppercase leading-none md:text-5xl" data-id="element-668" data-mp="xkk025onrfiv">
        A complete system fits better
      </h2>
      <p className="mt-4 text-titanium" data-id="element-669" data-mp="snbdzu0e2rcc">{message}</p>

      <div className="mt-8 grid grid-cols-2 gap-px overflow-hidden rounded-xl border mf-hairline bg-white/10" data-id="element-670" data-mp="1q9qv2uowlmzd">
        <div className="flex flex-col bg-navy p-5 md:p-6" data-id="element-671" data-mp="1l9w7p14c7fj2">
          <span className="text-xs uppercase tracking-[0.12em] text-titanium/70" data-id="element-672" data-mp="1gjfrxad1nhtj">Your selection</span>
          <span className="mt-2 font-display text-5xl font-semibold leading-none" data-id="element-673" data-mp="1bkcmhot5j9l1">{qty}</span>
          <span className="text-sm text-titanium" data-id="element-674" data-mp="1bii86tcdyfpx">individual lights</span>
          <span className="mt-4 text-xl font-semibold" data-id="element-675" data-mp="2911jn575pno3">{m(ind.total)}</span>
          <div className="mt-4" data-id="element-676" data-mp="2488faiflohcj">
            <WarrantyTag tier={warrantyConfig.individual} data-id="element-677" data-mp="246xdup9mnlol" />
          </div>
        </div>
        <div className="flex flex-col bg-[#0F2A47] p-5 md:p-6" data-id="element-678" data-mp="2c9m50afwptt">
          <span className="text-xs uppercase tracking-[0.12em] text-titanium/70" data-id="element-679" data-mp="6c09eu0rcntl">Complete system</span>
          <span className="mt-2 font-display text-5xl font-semibold leading-none" data-id="element-680" data-mp="3opzslsopz9gk">{s.bundle.qty}</span>
          <span className="text-sm text-titanium" data-id="element-681" data-mp="3tp426kfk397f">lights</span>
          <span className="mt-4 text-xl font-semibold" data-id="element-682" data-mp="3et4uhawczb2t">{m(s.total)}</span>
          <div className="mt-4" data-id="element-683" data-mp="3euzhcur6xd9j">
            <WarrantyTag tier={s.bundle.warranty} data-id="element-684" data-mp="3jshg5sbhuc3t" />
          </div>
        </div>
      </div>

      <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-685" data-mp="35sgg2f31z8pe">
        <button type="button" onClick={() => onAccept(s.bundle.id)} className={`${buttonClasses('primary')} flex-1`} data-id="element-686" data-mp="35u1cybcub3qf">
          Switch to {s.bundle.qty}-light system
        </button>
        <button type="button" onClick={onDecline} className={`${buttonClasses('secondary')} flex-1`} data-id="element-687" data-mp="141d3vldilm2q">
          Keep my {qty} {qty === 1 ? 'light' : 'lights'}
        </button>
      </div>
    </div>;
}